<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center">
    <button (click)="goBack()" class="btn btn-primary"><fa-icon [icon]="faCircleArrowLeft"></fa-icon></button>
    <h1 class="fs-2 fw-light mb-0">Manage Maintenance</h1>
    <button (click)="goHome()" class="btn btn-info"><fa-icon [icon]="faHomeAlt"></fa-icon></button>
  </div>

  <form [formGroup]="generateForm" class="mt-4">
    <div class="form-group my-4">
      <label class="form-label">Period Start</label>
      <input class="form-control" type="date" formControlName="periodStart" [ngClass]="{ 'is-invalid': f.periodStart.touched && f.periodStart.errors }"/>
    </div>

    @if (showAdvancedOptions) {
      <div class="form-group my-4">
        <label class="form-label">Period End</label>
        <input class="form-control" type="date" formControlName="periodEnd" [ngClass]="{ 'is-invalid': f.periodEnd.touched && f.periodEnd.errors }"/>
      </div>
    }

    <div class="form-group my-4">
      <label class="form-label">Execution Type</label>
      <select class="form-select form-control" formControlName="executionType">
        <option value="maintenance">Maintenance</option>
        <option value="rent">Rent</option>
        <option value="loan">Loan</option>
        <option value="adjustment">Adjustment</option>
      </select>
    </div>

    <button type="button" (click)="toggleAdvanced()" class="btn btn-outline-primary my-2">
      {{ showAdvancedOptions ? 'Hide Advance Options' : 'Advance Options' }}
      @if (showAdvancedOptions) {
        <fa-icon [icon]="faChevronUp"></fa-icon>
      }
      @if (!showAdvancedOptions) {
        <fa-icon [icon]="faChevronDown"></fa-icon>
      }
    </button>

    @if (showAdvancedOptions) {
      <div>
        <div class="form-group my-4">
          <label class="form-label">Amount</label>
          <input class="form-control" type="text" placeholder="5000" formControlName="amount"/>
        </div>
        <div class="form-group my-4">
          <label class="form-label">Unit Number</label>
          <input class="form-control" type="text" placeholder="1" formControlName="unitNumber"/>
        </div>
        <div class="form-group my-4">
          <label class="form-label">Description</label>
          <input class="form-control" type="text" placeholder="Maintenance payment" formControlName="description"/>
        </div>
      </div>
    }

    <div class="mt-4">
      <button [disabled]="isGenerating" type="button" class="btn btn-primary w-100" (click)="generate()">
        Generate @if (!isGenerating) {
          <fa-icon [icon]="faPaperPlane"></fa-icon>
        }
        @if (isGenerating) {
          <span class="spinner-border spinner-border-sm mr-1"></span>
        }
      </button>
    </div>
  </form>
</div>
